import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-sortdirection-new',
  templateUrl: './sortdirection-new.component.html',
  styleUrl: './sortdirection-new.component.css'
})
export class SortdirectionNewComponent {
    @Input() property: string = ''
    @Input() direction: string = ''
}

